import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from 'flarum/common/components/Link';
import humanTime from 'flarum/common/helpers/humanTime';
/**
 * /u/:username/launcher — what this person's launcher has reported.
 *
 * Only the person themselves and staff can load it: the reports say which
 * distro someone runs, which GPU they have and when they were at their machine,
 * which is more than a forum profile normally gives away. The VERDICTS are
 * public — they are in the update threads — but the per-person history is not.
 */
export default class UserLauncherPage extends UserPage {
  reports = [];
  tokens = [];
  loading = true;
  denied = false;
  oninit(vnode) {
    super.oninit(vnode);
    this.loadUser(m.route.param('username'));
  }
  show(user) {
    super.show(user);
    this.load(user.id());
  }
  load(userId) {
    app.request({
      method: 'GET',
      url: `${app.forum.attribute('apiUrl')}/launcher/record?user=${userId}`,
      errorHandler: error => {
        // 403 is the ordinary answer for somebody else's profile, so it is
        // rendered as a sentence rather than an alert.
        if (error?.status === 403 || error?.status === 401) {
          this.denied = true;
          this.loading = false;
          m.redraw();
          return false;
        }
      }
    }).then(result => {
      this.reports = result.reports;
      this.tokens = result.tokens;
      this.loading = false;
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
  revoke(token) {
    if (!confirm(app.translator.trans('blizznux-launcher.forum.record.revoke_confirm'))) return;
    app.request({
      method: 'POST',
      url: `${app.forum.attribute('apiUrl')}/launcher/tokens/revoke`,
      body: {
        id: token.id
      }
    }).then(() => {
      token.revokedAt = new Date().toISOString();
      m.redraw();
    });
  }
  content() {
    if (this.loading) return m(LoadingIndicator, null);
    if (this.denied) {
      return m("div", {
        className: "LauncherRecord"
      }, m("p", {
        className: "LauncherRecord-empty"
      }, app.translator.trans('blizznux-launcher.forum.record.private')));
    }
    return m("div", {
      className: "LauncherRecord"
    }, this.tokenSection(), this.reportSection());
  }
  tokenSection() {
    if (!this.tokens.length) return null;
    return m("section", {
      className: "LauncherRecord-section"
    }, m("h3", null, app.translator.trans('blizznux-launcher.forum.record.installs')), m("ul", {
      className: "LauncherRecord-installs"
    }, this.tokens.map(t => m("li", {
      className: t.revokedAt ? 'is-revoked' : ''
    }, m("span", {
      className: "LauncherRecord-install"
    }, t.launcher ? `v${t.launcher}` : app.translator.trans('blizznux-launcher.forum.record.unknown_version'), ' · ', m("code", null, (t.installId || '').slice(0, 13))), m("span", {
      className: "LauncherRecord-meta"
    }, t.revokedAt ? app.translator.trans('blizznux-launcher.forum.record.revoked') : t.lastUsedAt ? app.translator.trans('blizznux-launcher.forum.record.last_used', {
      when: humanTime(t.lastUsedAt)
    }) : app.translator.trans('blizznux-launcher.forum.record.never_used')), !t.revokedAt && this.isSelf() && m(Button, {
      className: "Button Button--link",
      onclick: () => this.revoke(t)
    }, app.translator.trans('blizznux-launcher.forum.record.revoke'))))));
  }
  reportSection() {
    if (!this.reports.length) {
      return m("p", {
        className: "LauncherRecord-empty"
      }, app.translator.trans('blizznux-launcher.forum.record.empty'));
    }
    return m("section", {
      className: "LauncherRecord-section"
    }, m("h3", null, app.translator.trans('blizznux-launcher.forum.record.reports')), m("ul", {
      className: "LauncherRecord-reports"
    }, this.reports.map(r => m("li", null, m("span", {
      className: `LauncherRecord-outcome is-${r.outcome || r.type}`
    }, this.icon(r)), m("span", {
      className: "LauncherRecord-what"
    }, r.what || app.translator.trans('blizznux-launcher.forum.record.bug'), r.version ? m("span", {
      className: "LauncherRecord-version"
    }, " ", r.version) : null), m("span", {
      className: "LauncherRecord-meta"
    }, humanTime(r.createdAt), r.launcher ? ` · v${r.launcher}` : '', r.discussion ? m('[', null, ' · ', m(Link, {
      href: app.route('discussion', {
        id: r.discussion
      })
    }, app.translator.trans('blizznux-launcher.forum.record.thread'))) : null)))));
  }
  icon(r) {
    if (r.type === 'bug') return '🐞';
    switch (r.outcome) {
      case 'perfect':
      case 'ok':
        return '✅';
      case 'issues':
        return '⚠️';
      case 'broken':
      case 'failed':
        return '⛔';
      default:
        return '•';
    }
  }
  isSelf() {
    return !!app.session.user && this.user && app.session.user.id() === this.user.id();
  }
}
flarum.reg.add('blizznux-launcher', 'forum/components/UserLauncherPage', UserLauncherPage);